<template>
  <v-container fluid>
    <PageTitle>
      Disclaimers
      <template v-slot:buttons>
        <v-btn :to="{name: 'admin.disclaimer.create'}"
               color="primary">
          New Disclaimer
        </v-btn>
      </template>
    </PageTitle>

    <v-card>
      <v-simple-table>
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Status
          </th>
          <th>
            Title
          </th>
          <th>
            Content
          </th>
          <th>
            Created
          </th>
          <th>
            Updated
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="disclaimer in disclaimers"
            :key="disclaimer.id">
          <td>
            <router-link :to="{name:'admin.disclaimer.edit', params: {disclaimerID: disclaimer.id}}">
              {{ disclaimer.name }}
            </router-link>
          </td>
          <td>
            {{ disclaimer.status }}
          </td>
          <td>
            {{ disclaimer.title }}
          </td>
          <td>
            {{ disclaimer.content}}
          </td>
          <td class="text-no-wrap">
            {{ disclaimer.created_at | datetime }}
          </td>
          <td class="text-no-wrap">
            {{ disclaimer.updated_at | datetime }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import {mapGetters} from 'vuex';

export default {
  components: {PageTitle},
  computed: {
    ...mapGetters([
      'disclaimers',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchDisclaimers');
    }
  }
}
</script>
